import { h, Component, Element, Prop, Host } from '@stencil/core';
import { toggleClass } from '../../utils';

import type { Screen, SubmitEventArg } from '../../types';

@Component({
  tag: `om-split-layout`,
  styleUrls: ['./split-layout.css', 'max-size.css'],
  scoped: true,
})
export class SplitLayout {
  @Element() el: HTMLElement;
  @Prop() screen: Screen;
  @Prop() unmount: () => void;
  @Prop() handleSubmit: (d: SubmitEventArg) => void;
  @Prop() handleAction?: (d: any) => void; // For notification overlay
  @Prop() handleMinimize?: () => void; // For mini overlay collapse
  @Prop() imagePosition: 'left' | 'right' | 'top' | 'bottom' = 'left';
  @Prop() maxSize?: boolean;
  @Prop() isMobileViewport?: boolean = false;
  @Prop() isMiniOverlayEnabled?: boolean = false;
  @Prop() overlayState?: any;
  @Prop() overlayStore?: any;

  toggleClass: typeof toggleClass = toggleClass.bind(this);

  private createClass(className: string) {
    let cn = this.isMobileViewport ? `${className} is-mobile-viewport` : className;
    if (['left', 'right'].includes(this.imagePosition)) cn += ' horizontal';
    if (['bottom', 'top'].includes(this.imagePosition)) cn += ' vertical';
    if (this.imagePosition === 'right') cn += ' row-reverse';
    if (this.imagePosition === 'bottom') cn += ' column-reverse';
    if (this.maxSize) cn += ' max-size';
    return cn;
  }

  render() {
    return (
      <Host>
        {this.handleMinimize && this.isMiniOverlayEnabled && this.screen !== 'success' && (
          <om-minimize-button
            handleMinimize={this.handleMinimize}
            overlayState={this.overlayState}
            overlayStore={this.overlayStore}
          />
        )}
        {this.handleAction ? (
          <om-notification-close-button handleClose={this.unmount} />
        ) : (
          <om-close-button handleClose={this.unmount} />
        )}
        <div class={this.createClass('container')} role="dialog" aria-modal="true" tabindex={-1}>
          <div>{this.handleAction ? <om-notification-bg-images /> : <om-bg-images />}</div>
          <div class="form-panel">
            {this.handleAction ? (
              <om-notification-screen-switcher handleAction={this.handleAction} unmount={this.unmount} />
            ) : (
              <om-screen-switcher handleSubmit={this.handleSubmit} unmount={this.unmount} />
            )}
          </div>
        </div>
      </Host>
    );
  }

  componentWillRender() {
    this.toggleClass(this.maxSize, 'max-size');
    this.toggleClass(
      this.isMobileViewport || this.imagePosition === 'top' || this.imagePosition === 'bottom',
      'vertical',
    );
  }
}
